import { render } from "./GetBrowser.vue?vue&type=template&id=7f49f7dd"
import script from "./GetBrowser.vue?vue&type=script&lang=js"
export * from "./GetBrowser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__